import { Component } from '@angular/core';
import { SurgeryCitizenService } from '../../services/surgery/surgery.citizen.service';
import { header } from './config/surgeries-citizen.config';

@Component({
  selector: 'app-surgeries-citizen',
  templateUrl: './surgeries-citizen.component.html',
  styleUrl: './surgeries-citizen.component.scss'
})
export class SurgeriesCitizenComponent {
  constructor(private surgeryCitizenService: SurgeryCitizenService) {}

  ngOnInit() {
    this.surgeryCitizenService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
